export enum ExperienceBarStep {
  LEVEL = 'LEVEL',
  LEVELUP = 'LEVELUP',
  REWARDS = 'REWARDS',
}
